module.exports = __webpack_public_path__ + "static/media/YF51_4.af7d05f7.jpg";